module.exports = __webpack_public_path__ + "static/media/MD_Cincy_header.cb9b1d42.jpg";